import {
  EMBEDDED_AGENT_PANEL_QUEUE_OPEN_WIDTH,
  EMBEDDED_AGENT_PANEL_WIDTH,
} from '../pages/ScopedAgentChatPanel';
import {
  CONTEXT_AGENT_SPRITE_SIZE,
  WIDGET_DEFAULT_INSET,
  WIDGET_VIEWPORT_MARGIN,
} from './widgetConstants';

export function getDefaultWidgetAnchor() {
  if (typeof window === 'undefined') {
    return { x: WIDGET_DEFAULT_INSET, y: WIDGET_DEFAULT_INSET };
  }

  return {
    x: window.innerWidth - CONTEXT_AGENT_SPRITE_SIZE - WIDGET_DEFAULT_INSET,
    y: window.innerHeight - CONTEXT_AGENT_SPRITE_SIZE - WIDGET_DEFAULT_INSET,
  };
}

export function clampWidgetAnchor(anchor) {
  if (typeof window === 'undefined') {
    return anchor;
  }

  const maxX = window.innerWidth - CONTEXT_AGENT_SPRITE_SIZE - WIDGET_VIEWPORT_MARGIN;
  const maxY = window.innerHeight - CONTEXT_AGENT_SPRITE_SIZE - WIDGET_VIEWPORT_MARGIN;

  return {
    x: Math.min(Math.max(WIDGET_VIEWPORT_MARGIN, anchor.x), maxX),
    y: Math.min(Math.max(WIDGET_VIEWPORT_MARGIN, anchor.y), maxY),
  };
}

export function getWidgetPanelHeight() {
  if (typeof window === 'undefined') {
    return 640;
  }

  return Math.min(640, window.innerHeight - 120);
}

export function getWidgetPanelWidth(taskQueueOpen = false) {
  return taskQueueOpen
    ? EMBEDDED_AGENT_PANEL_QUEUE_OPEN_WIDTH
    : EMBEDDED_AGENT_PANEL_WIDTH;
}

export function clampWidgetPanelAnchor(anchor, panelWidth = EMBEDDED_AGENT_PANEL_WIDTH) {
  if (typeof window === 'undefined') {
    return anchor;
  }

  const panelHeight = getWidgetPanelHeight();
  const margin = WIDGET_VIEWPORT_MARGIN;

  return {
    x: Math.min(Math.max(margin, anchor.x), window.innerWidth - panelWidth - margin),
    y: Math.min(Math.max(margin, anchor.y), window.innerHeight - panelHeight - margin),
  };
}

/** Keep the panel's right edge fixed when widening for the task-queue sidecar. */
export function adjustWidgetPanelAnchorForWidth(anchor, previousWidth, nextWidth) {
  if (!anchor || previousWidth === nextWidth) {
    return clampWidgetPanelAnchor(anchor, nextWidth);
  }

  const rightEdge = anchor.x + previousWidth;
  return clampWidgetPanelAnchor(
    { x: rightEdge - nextWidth, y: anchor.y },
    nextWidth
  );
}

/** Stack panel over sprite — bottom-right corners aligned. */
export function getWidgetPanelAnchorFromSprite(spriteAnchor, taskQueueOpen = false) {
  const panelWidth = getWidgetPanelWidth(taskQueueOpen);
  const panelHeight = getWidgetPanelHeight();

  return clampWidgetPanelAnchor(
    {
      x: spriteAnchor.x + CONTEXT_AGENT_SPRITE_SIZE - panelWidth,
      y: spriteAnchor.y + CONTEXT_AGENT_SPRITE_SIZE - panelHeight,
    },
    panelWidth
  );
}
